import React from 'react';
export default (function (props) {
  var color = props.color,
      size = props.size,
      className = props.className,
      style = props.style;
  color = color ? color : 'currentColor';
  size = size ? size : '100%';
  return /*#__PURE__*/React.createElement("svg", {
    style: style,
    className: className,
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 15 36",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hardware-/-wrench"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "\uD83C\uDFA8-Icon-Color",
    points: "15 14.4 9.68085106 14.4 9.68085106 0 0 19.8 6.13475177 19.8 6.13475177 36"
  }))));
});